import { render, staticRenderFns } from "./boxset-catalog.vue?vue&type=template&id=094b0590&"
import script from "./boxset-catalog.vue?vue&type=script&lang=js&"
export * from "./boxset-catalog.vue?vue&type=script&lang=js&"
import style0 from "./boxset-catalog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports